const company = () => import(/* webpackPrefetch: true */ '@/views/private/setting/company/index.vue')

const position = () => import(/* webpackPrefetch: true */ '@/views/private/setting/position/index.vue')

const doc = () => import(/* webpackPrefetch: true */ '@/views/private/setting/doc/index.vue')

const salary = () => import(/* webpackPrefetch: true */ '@/views/private/setting/salary/index.vue')

const category = () => import(/* webpackPrefetch: true */ '@/views/private/setting/category/index.vue')

const routes = [
  {
    path: "/setting/company",
    name: "Perusahaan",
    component: company,
    meta: {
      title: "Perusahaan"
    }
  },
  
  {
    path: "/setting/position",
    name: "Jabatan",
    component: position,
    meta: {
      title: "Jabatan"
    }
  },

  {
    path: "/setting/doc",
    name: "Tipe Dokumen",
    component: doc,
    meta: {
      title: "Tipe Dokumen"
    }
  },

  {
    path: "/setting/salary",
    name: "Gaji",
    component: salary,
    meta: {
      title: "Gaji"
    }
  },

  {
    path: "/setting/category",
    name: "Kategori",
    component: category,
    meta: {
      title: "Kategori"
    }
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})